import { AnimatePresence, motion } from "motion/react";


export function StickerTypingIndicator() {

    return (
        <AnimatePresence>
            <motion.div
                key="typing-indicator"
                initial={{ opacity: 0, y: 5, x: '-50%' }}
                animate={{ opacity: 1, y: 0, x: '-50%' }}
                exit={{ opacity: 0, y: 0, x: '-50%' }}
                transition={{
                    opacity: { duration: 0.1, ease: 'easeOut' },
                    y: { type: 'spring', stiffness: 500, damping: 10 }
                }}
                className='absolute -bottom-2  drop-shadow-[0_0_4px_rgba(0,0,0,0.3)] shadow-black/30 bg-white z-10 py-0.5 px-1 rounded-full left-1/2'>
                <div className='flex gap-0.5 justify-center items-center pt-0.5'>
                    <div className='h-1.5 w-1.5 bg-gray-400 rounded-full animate-typing-bounce [animation-delay:-0.3s]'></div>
                    <div className='h-1.5 w-1.5 bg-gray-400 rounded-full animate-typing-bounce [animation-delay:-0.15s]'></div>
                    <div className='h-1.5 w-1.5 bg-gray-400 rounded-full animate-typing-bounce'></div>
                </div>
            </motion.div>
        </AnimatePresence >
    );
}